<ng-container *ngIf="pages <= 15">
    <button *ngFor="let i of _pages" [ngClass]="{ 'selected': current == i }" (click)="select(i)">{{ i }}</button>
</ng-container>
<ng-container *ngIf="pages > 15">
    <div class="search-panel">
        <input [(ngModel)]="chPage"><button color="warn" (click)="changePage()"><mat-icon>cached</mat-icon></button>
    </div>
    <ng-container *ngFor="let i of _pages">
        <button *ngIf="i != 'space'" [ngClass]="{ 'selected': current == i }" (click)="select(i)">{{ i }}</button>
        <div *ngIf="i == 'space'" class="space">. . .</div>
    </ng-container>
</ng-container>
